export default __webpack_public_path__ + "static/media/8.84f5a9f8.jpg";